import styled from "styled-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const AnchorCellWrapper = styled(FlexRow)`
    width: 100%;
    gap: 7px;

    ${FlexRow} {
        flex: 1 1;
        overflow: hidden;
    }
`;
export const ImageIconContainer = styled.div`
    flex: 0 1;
`;
export const TooltipImage = styled.img`
    height: 100%;
    width: 100%;
    object-fit: contain;
`;
export const TooltipImageContainer = styled.div`
    background-color: ${colorsPalettes.carbon["0"]};
    border-radius: 6px;
    padding: 8px;
    width: 182px;
    height: 100px;
`;
export const TooltipContentContainer = styled(FlexColumn)`
    gap: 8px;

    a {
        cursor: pointer;
        ${setFontVariant("tooltip", colorsPalettes.blue[300])}
    }
`;
